import { render } from "./HelpPhases.vue?vue&type=template&id=9705477a&ts=true"
import script from "./HelpPhases.vue?vue&type=script&lang=ts"
export * from "./HelpPhases.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__